"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebugState = exports.useNamedState = void 0;

var react_1 = require("react");

var NamedState = function NamedState(stateName, stateValue) {
  if (typeof stateName !== "string") {
    throw new Error("State name in useNamedState should be string");
  }

  var _react_1$useState = react_1.useState(_defineProperty({}, stateName, stateValue)),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      customState = _react_1$useState2[0],
      setCustomState = _react_1$useState2[1];

  var namedState = customState[stateName]; // It either accepts cb or the new state (T)

  var setNamedState = function setNamedState(setStateCallback) {
    // If it is a cb function
    if (setStateCallback instanceof Function) {
      setCustomState(function (prevState) {
        var requiredPrevState = prevState[stateName];
        var newState = setStateCallback(requiredPrevState);
        return Object.assign(Object.assign({}, prevState), _defineProperty({}, stateName, newState));
      });
    } // If it is direct assignment
    else {
        setCustomState(function (prevState) {
          return Object.assign(Object.assign({}, prevState), _defineProperty({}, stateName, setStateCallback));
        });
      }
  };

  return [namedState, setNamedState];
};

exports.useNamedState = NamedState;

var DebugState = function DebugState(stateName, stateValue, extraArgs) {
  if (typeof stateName !== "string" && typeof stateName !== "function") {
    throw new Error("State name in useDebugState should be string or a function that returns string");
  }

  var _react_1$useState4 = react_1.useState(stateValue),
      _react_1$useState5 = _slicedToArray(_react_1$useState4, 2),
      customState = _react_1$useState5[0],
      setCustomState = _react_1$useState5[1];

  if (typeof stateName === "string") react_1.useDebugValue(stateName);else react_1.useDebugValue({
    state: customState,
    extraArgs: extraArgs
  }, stateName);
  return [customState, setCustomState];
};

exports.useDebugState = DebugState;